import React from 'react';
import { Box, Typography, Grid, Paper, IconButton } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { getStatsConfig } from '../utils/dashboardUtils';

/**
 * Dashboard istatistik kartları bölümü
 */
const StatsSection = ({ statsData, loading, onRefresh }) => {
  const { t } = useTranslation();
  const stats = getStatsConfig(statsData, t);

  return (
    <Box className="stats-section">
      <Box className="stats-header">
        <Typography className="stats-title">
          {t('statistics')}
        </Typography>
        <IconButton 
          className="refresh-button"
          onClick={onRefresh} 
          disabled={loading}
        >
          <RefreshIcon />
        </IconButton>
      </Box>

      <Grid container spacing={3}>
        {loading ? (
          <Grid item xs={12}>
            <Paper sx={{ p: 3, textAlign: 'center', borderRadius: '16px' }}>
              <Typography>{t('loading_data')}</Typography>
            </Paper>
          </Grid>
        ) : (
          stats.map((stat, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Paper 
                className="stat-card"
                elevation={0}
                sx={{
                  '--stat-color': stat.color,
                  '--stat-color-light': stat.colorLight,
                  '--stat-bg': stat.bg
                }}
              >
                <Box className="stat-icon">
                  {stat.icon}
                </Box>
                <Typography className="stat-value">
                  {stat.value}
                </Typography>
                <Typography className="stat-label">
                  {stat.title}
                </Typography>
              </Paper>
            </Grid>
          ))
        )}
      </Grid>
    </Box>
  );
};

export default StatsSection;
